// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__24JRs","item":"PaymentsMobile_item__2ZsHr","label":"PaymentsMobile_label__7bCW3","amount":"PaymentsMobile_amount__3PoRZ"};